import React from "react";
import { createPortal } from "react-dom";
import Button from "./Button";

const AppRedirectModal = ({ app, onContinue, onCancel }) => {
  console.log("🎨 Rendu du modal pour:", app?.name);
  
  const modalContent = (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8 animate-fade-in">
        <div className="flex flex-col items-center text-center">
          {/* Logo de l'application */}
          {app.logo_url && (
            <div className="w-20 h-20 bg-[#F5F8FF] rounded-xl flex items-center justify-center mb-6">
              <img
                src={app.logo_url}
                alt={app.name}
                className="h-14 w-14 object-contain"
              />
            </div>
          )}

          {/* Titre */}
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#034D82] mb-3 font-montserrat">
            Connexion réussie !
          </h2>

          {/* Message */}
          <p className="text-[#717182] font-medium font-segoe text-base mb-8 leading-relaxed">
            Vous êtes maintenant connecté. Souhaitez-vous accéder directement à{" "}
            <span className="font-bold text-[#034D82]">{app.name}</span> ou
            revenir à la liste des applications ?
          </p>

          {/* Boutons d'action */}
          <div className="flex flex-col sm:flex-row gap-4 w-full">
            <Button
              onClick={onCancel}
              variant="ghost"
              className="flex-1 py-1"
            >
              Voir les applications
            </Button>
            <Button
              onClick={onContinue}
              variant="primary"
              className="flex-1 py-1"
            >
              Accéder à {app.name}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default AppRedirectModal;
